<template>
    <svg width="32" height="44" viewBox="0 0 32 44" fill="none" xmlns="http://www.w3.org/2000/svg" :class="className">
        <path d="M17.875 4H4.75C3.75544 4 2.80161 4.37928 2.09835 5.05442C1.39509 5.72955 1 6.64522 1 7.6V36.4C1 37.3548 1.39509 38.2705 2.09835 38.9456C2.80161 39.6207 3.75544 40 4.75 40H27.25C28.2446 40 29.1984 39.6207 29.9016 38.9456C30.6049 38.2705 31 37.3548 31 36.4V16.6L17.875 4Z" stroke="#202830" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M18 4V17H31" stroke="#202830" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
</template>

<script>
export default {
    name: 'IconDocument',

    props: ['className']
};
</script>

<style lang="scss">
@import "Icons";
</style>
